<template>
  <div>
    <b-row>
      <b-col md="12" class="my-1">
        <b-form inline> 
          <b-button @click="goTo('index')" variant="transparent" size="sm" class="pull-left">
            <font-awesome-icon icon="angle-left" size="2x" />
          </b-button>
          &nbsp;
          <h3 class="text-themecolor my-1">{{$t('carpetline.detailsvanorder')}} - {{order.number}}</h3>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">{{$t('carpetline.algemenegegevens')}}</h4>
            <div v-if="order && order.number">
              <b-row>
                  <b-col col md="12" lg="6"><small class="text-muted">{{$t('datatables.referentie')}}</small></b-col>
                  <b-col col md="12" lg="6"><h6>{{order.deliveredBy != '' ? order.reference : 'Niet opgegeven'}}</h6></b-col>
              </b-row>
              <b-row>
                  <b-col col md="12" lg="6"><small class="text-muted">{{$t('carpetline.orderdatum')}}</small></b-col>
                  <b-col col md="12" lg="6"><h6>{{order.orderDate | date}}</h6></b-col>
              </b-row>
              <b-row>
                  <b-col col md="12" lg="6"><small class="text-muted">{{$t('carpetline.leverdatum')}}</small></b-col>
                  <b-col col md="12" lg="6"><h6>{{order.deliveryDate | date}}</h6></b-col>
              </b-row>
            </div>
            <div v-else>
              <content-placeholders>
                <content-placeholders-heading/>
                <content-placeholders-text :lines="2"/>
              </content-placeholders>
            </div>
          </div>
        </div>
      </b-col>
      <b-col md="6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">{{$t('carpetline.overigegegevens')}}</h4>
            <div v-if="order && order.number">
              <b-row>
                  <b-col col md="12" lg="6"><small class="text-muted">{{$t('carpetline.leveranciertapijt')}}</small></b-col>
                  <b-col col md="12" lg="6"><h6>{{order.supplierCarpet != '' ? order.supplierCarpet : 'Niet opgegeven'}}</h6></b-col>
              </b-row>
              <b-row>
                  <b-col col md="12" lg="6"><small class="text-muted">{{$t('carpetline.vervoergereedproduct')}}</small></b-col>
                  <b-col col md="12" lg="6"><h6>{{order.transportFinishedProduct != '' ? order.transportFinishedProduct : 'Niet opgegeven'}}</h6></b-col>
              </b-row>
              <b-row>
                  <b-col col md="12" lg="6"><small class="text-muted">{{$t('datatables.status')}}</small></b-col>
                  <b-col col md="12" lg="6"><h6>{{order.status != undefined ? orderStatuses.filter(({key}) => key == order.status)[0].value : 'Onbekend'}}</h6></b-col>
              </b-row>
            </div>
            <div v-else>
              <content-placeholders>
                <content-placeholders-heading/>
                <content-placeholders-text :lines="2"/>
              </content-placeholders>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <OrderLines :orderLines="order.orderLines"/>
    <b-row>
      <b-col md="12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">{{$t('carpetline.opmerking')}}</h4>
            <div v-if="order && order.number">
              <b-row>
                  <b-col col md="12" lg="6"><h6>{{order.note != '' ? order.note : 'Niet opgegeven'}}</h6></b-col>
              </b-row>
            </div>
            <div v-else>
              <content-placeholders>
                <content-placeholders-heading/>
                <content-placeholders-text :lines="2"/>
              </content-placeholders>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-button @click="goTo('index')" variant="secondary">{{$t('buttons.terugnaaroverzicht')}}</b-button>
      </b-col>
    </b-row>
    <br/>
  </div>
</template>

<script>
  'use strict';
   //Import store
  import {mapGetters, mapActions} from 'vuex';
  //Import components
  import OrderLines from "./orderlines/OrderLines";
  export default {
    name: 'order-detail',
    computed: {
      ...mapGetters('carpetline', ['order','orderStatuses']),
      ...mapGetters('core', ['administration']),
    },
    components: {
      OrderLines
    },
    methods: {
      ...mapActions('carpetline',['find']),
      goTo(name) {
        this.$router.push({ name: `orders:${name}` });
      }
    },
    created() {
      var vm = this;
      vm.find({
        resource: 'orders',
        id: vm.$route.params.orderId
      });
    },
  };

</script>
